import React from 'react';
import MetricFormatter from 'dashboards/MetricFormatter'

// Gets the correct MetricFormatter for each metric based on metric name. We need this because we are looping through each metric now rather than hard coding each metric
const GetFormatter = (props) => {
  let Formatter;
  let metric = props.metricName.toLowerCase();

  if (props.tick == true) {
    if (metric.includes("roas") || metric.includes("aov") || metric.includes("cpa") || metric.includes("cpc")) {
      Formatter = MetricFormatter.CalculatedMonetaryTick;
    } else if (metric.includes("revenue") || metric.includes("spend")) {
      Formatter = MetricFormatter.MonetaryTick;
    } else if (metric.includes("ctr") || metric.includes("cvr") || metric.includes("bounce_rate")) {
      Formatter = MetricFormatter.CalculatedTick;
    } else {
      Formatter = MetricFormatter.DefaultTick;
    }
  } else {
    if (metric.includes("traffic")) {
      Formatter = MetricFormatter.Sessions;
    } else if (metric.includes("impressions")) {
      Formatter = MetricFormatter.Impressions;
    } else if (metric.includes("phone_calls")) {
      Formatter = MetricFormatter.PhoneCalls;
    } else if (metric.includes("search_visibility")) {
      Formatter = MetricFormatter.SearchVisibility;
    } else if (metric.includes("clicks")) {
      Formatter = MetricFormatter.Clicks;
    } else if (metric.includes("revenue") || metric.includes("spend")) {
      Formatter = MetricFormatter.Revenue;
    } else if (metric.includes("bounce_rate")) {
      Formatter = MetricFormatter.BounceRate;
    } else if (metric.includes("roas")) {
      Formatter = MetricFormatter.ROAS;
    } else if (metric.includes("aov")) {
      Formatter = MetricFormatter.AOV;
    } else if (metric.includes("cpa")) {
      Formatter = MetricFormatter.CPA;
    } else if (metric.includes("cpc")) {
      Formatter = MetricFormatter.CPC;
    } else if (metric.includes("cvr")) {
      Formatter = MetricFormatter.CVR;
    } else if (metric.includes("ctr")) {
      Formatter = MetricFormatter.CTR;
    } else if (metric.includes("conversions")) {
      Formatter = MetricFormatter.Conversions;
    } else if (metric.includes("backlinks")) {
      Formatter = MetricFormatter.Backlinks;
    } else {
      Formatter = MetricFormatter.Sessions;
    }
  }

  return Formatter;
}

export default GetFormatter;
